import {
  HookOptions,
  useStatsQuery,
} from "../extensions/sw/modules/stats/hooks";
import { StatsQuery } from "../extensions/sw/modules/stats/types";
import { MatchFilter } from "../libs/statsFilters";
import { WorkerQueryOptions } from "../libs/workers/types";
import { GlobalStatsSelection } from "../types/stats";

export type AggregatedMatchesSummary = {
  id: string;
  title: string;
  totalMatches: number;
  totalEnigmas: number;
  completedMatches: number;
  totalHints: number;
  totalErrors: number;
  ratedMatches: number;
  totalRating: number;
  /**
   * Total time spent on matches in ms
   */
  totalTime: number;
  totalRequestedSolutions: number;
  /**
   * Avg time spent on enigmas in seconds
   */
  avgTimePerEnigma: number;
};

export const useCityEscapesSummaries = (
  data: {
    selection?: GlobalStatsSelection;
    filters?: MatchFilter;
    opts?: WorkerQueryOptions;
  },
  opts: HookOptions<typeof StatsQuery.CITY_ESCAPE_SUMMARIES>
) => {
  return useStatsQuery(
    {
      type: StatsQuery.CITY_ESCAPE_SUMMARIES,
      data: {
        productIds: data.selection?.productIds,
        cityEscapeIds: data.selection?.cityEscapeIds,
        filters: data.filters,
      },
      opts: {
        ...data.opts,
        traceKey: data.opts?.traceKey ?? "useCityEscapeSummaries",
      },
    },
    opts
  );
};
